module.exports = __webpack_public_path__ + "img/addition-black-and-white-black-and-white-374918.bc489ecd.jpg";